let mutations = {
  SET_NUMBER_OF_STEPS (state, data) {
    state.numberOfSteps = data;
  },
  SET_CURRENT_STEP (state, data) {
    state.currentStep = data;
  },
  SET_SIGNUP_STATUS (state, data) {
    state.signupStatus = data;
  },
  SET_USER_EMAIL (state, data) {
    state.userEmail = data;
  },
  SET_WAIT_TIME (state, data) {
    localStorage.setItem('waitTime', data)
    state.waitTime = data;
  },
  SET_WAIT_MESSAGE (state, data) {
    state.waitMessage = data;
  },
  PRESET_EMAIL (state, data) {
    state.presetEmail = data;
  },
  SET_DMI_ELIGIBLE (state, data) {
    state.dmiEligible = data
  },
  SET_SIGNUP_MOBILE (state, data) {
    state.signupMobile = data
  }
};
export default mutations;



// WEBPACK FOOTER //
// ./src/store/signup/mutations.js